import React from 'react';
import {
  ListItem, ListItemText,
  TableRow, TableCell
} from '@material-ui/core';
import { MUISelect, MUITextBox } from 'components/FormHelpers/FormInputs';
import { compose } from 'recompose';
import _ from 'lodash';
import { GridSubmitAction } from '@ctsu/ctsu-mui-grid';
import { BoolToString } from 'components';
import { getEmptyValue } from 'helpers';
import { withChangeHandlers } from 'helpers/Change';

export const TxArm = ({
  treatmentAssignment, handleChange
}) => (
  <MUITextBox
    title="Treatment Assignment"
    margin="dense"
    multiline
    rowsMax="2"
    onChange={handleChange}
    value={getEmptyValue(treatmentAssignment)}
    validators={['maxStringLength:100']}
    errorMessages={['Maximum 100 characters allowed']}
    name="treatmentAssignment"
  />
);


export const Step = ({
  event, handleChange, regSteps
}) => (
  <MUISelect
    value={getEmptyValue(event)}
    name="event"
    onChange={handleChange}
    title="Step"
  >
    {_.map(regSteps, (item) => (
      <ListItem button value={item.step}>
        <ListItemText
          primary={item.step}
          secondary={item.description}
        />
      </ListItem>
    ))}
  </MUISelect>
);

function FundingRow(props) {
  const {
    state,
    handleChange,
    cancel,
    reset,
    regSteps
  } = props;

  const {
    fundingType,
    treatmentAssignment,
    isCollectInOpen,
    event
  } = state;

  return (
    <TableRow className="editedRow">
      <TableCell>
        <TxArm
          treatmentAssignment={treatmentAssignment}
          handleChange={handleChange}
        />
      </TableCell>
      <TableCell>
        <Step
          event={event}
          regSteps={regSteps}
          handleChange={handleChange}
        />
      </TableCell>
      <TableCell>
        {fundingType}
      </TableCell>
      <TableCell align='center'><BoolToString boolValue={isCollectInOpen} /></TableCell>
      <TableCell align='center'>
        <GridSubmitAction
          cancel={cancel}
          reset={reset}
        />
      </TableCell>
    </TableRow>

  );
}

const EditFundingRow = compose(withChangeHandlers)(FundingRow);

export default EditFundingRow;
